export default __webpack_public_path__ + "static/media/gallery-bowser.dad9ad15.webp";